const Flickity = require('flickity');
require('flickity-as-nav-for');

export default () => {

    const productSlider = document.querySelector('[data-product-slider]');
    const productNavSlider = document.querySelector('[data-product-slider-nav]');

    if (productSlider && productNavSlider) {


        window.addEventListener('load', () => {

            const parent = productSlider.parentNode;
            const next = parent.querySelector('[data-next]');
            const prev = parent.querySelector('[data-prev]');

            const main = new Flickity(productSlider, {
                contain: true,
                pageDots: false,
                prevNextButtons: false
            });

            const nav = new Flickity(productNavSlider, {
                asNavFor: productSlider,
                contain: true,
                pageDots: false,
                prevNextButtons: false
            });

            next.addEventListener('click', (e) => {
                e.preventDefault();
                main.next();
                return false;
            });

            prev.addEventListener('click', (e) => {
                e.preventDefault();
                main.previous();
                return false;
            });

        });
    }
}
